import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";

import AppContext from "../../context/AppContext";
import HomeIcon from "@mui/icons-material/Home";
import PositionedMenu from "./PositionedMenu";
import { Button } from "@mui/material";
import Logo from "../../../image/logo-rising.svg";
const DashboardHeader = () => {


    const { adminAuthInfo, setAdminAuthInfo, logoutAdmin } = useContext(AppContext);

    return <>
        <header className="dashboard-header elem-flex">
            <div id="header-row" className="app-header-row elem-row">
                <div className="dashboard-logo">
                <Link to="/" className="dashboard-name">Templates Manager v1.0</Link>
                </div>
                <div className="dashboard-right-menu">
                    <PositionedMenu />
                </div>
            </div>
        </header>
    </>
}


export default DashboardHeader;